import { type FC, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { FeedbackBox } from './FeedbackBox'
import styles from './InsightsFeedback.module.scss'
import classNames from 'classnames'

interface InsightsFeedbackProps {
  to: string
  onDismiss: VoidFunction
  onFeedbackClick: VoidFunction
}

export const InsightsFeedback: FC<InsightsFeedbackProps> = ({ to, onDismiss, onFeedbackClick }) => {
  const feedbackSentinelRef = useRef<HTMLDivElement>(null)
  const [showFeedback, setShowFeedback] = useState(false)
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null)

  useEffect(() => {
    const sentinel = feedbackSentinelRef.current
    if (!sentinel) return

    setPortalTarget(sentinel.parentElement)

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShowFeedback(true)
        observer.disconnect()
      }
    })
    observer.observe(sentinel)

    return () => observer.disconnect()
  }, [])

  return (
    <>
      <div ref={feedbackSentinelRef} />
      {portalTarget &&
        createPortal(
          <div className={styles.container}>
            <div className={styles.innerContainer}>
              <FeedbackBox
                className={classNames(styles.hidden, { [styles.visible]: showFeedback })}
                to={to}
                title='Shape what Insights shows you'
                subtitle='Missing a metric or have a suggestion?'
                onDismiss={onDismiss}
                onFeedbackClick={onFeedbackClick}
              />
            </div>
          </div>,
          portalTarget,
        )}
    </>
  )
}
